import { useContext } from 'react';
import { AuthContext } from '../lib/AuthProvider';

const useAuthentication = () => {
  return useContext(AuthContext);
};

export default useAuthentication;
